import axios from 'axios';
 const location =window.location.host;;
  export const basePort= location==="localhost:3000"? process.env.REACT_APP_LOCAL_API_PORT : process.env.REACT_APP_SERVER_API_PORT 
 console.log("basePort",basePort)
 const baseapi = axios.create({
  baseURL: basePort,  
});

export default baseapi
